import React from 'react'
import { InputTextAreaProps } from './types'

const InputTextArea = ({
    hideLabel = false,
    required = false,
    disabled = false,
    rows = 5,
    cols = 20,
    ...props
}: InputTextAreaProps) => {
    const classes = `${props.className} ${props.hasError ? 'error' : ''}`;
    return (
        <div className={`input-text-area ${classes}`}>
            <label
                className={hideLabel ? 'sr-only' : ''}
                htmlFor={props.id}>
                {props.label}
                {required ? '*' : ''}
            </label>
            <div className={`input-text-area__wrapper ${classes}`}>
                <textarea
                    disabled={disabled}
                    value={props.value}
                    id={props.id}
                    rows={rows}
                    cols={cols}
                    onChange={props.onChange}
                    placeholder={props.placeholder}
                    maxLength={props.maxLength || undefined}
                    onBlur={props.onBlur || undefined}
                    onFocus={props.onFocus || undefined}
                />
            </div>
        </div>
    );
}

export default InputTextArea;
